import { render, staticRenderFns } from "./PerformanceUnitList.vue?vue&type=template&id=098ad843&scoped=true&"
import script from "./PerformanceUnitList.vue?vue&type=script&lang=js&"
export * from "./PerformanceUnitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098ad843",
  null
  
)

export default component.exports